import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  px: 0.5,
  width: '100%',
};

export const accountButton: SxStyle = {
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption,
  fontWeight: 600,
};

export const accountTitle: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0.5, 1),
  backgroundColor: (p) => p.palette.primary[50],
  color: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(0.5),
};

export const action: SxStyle = {
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};
